let lastScrollTop = 0
let resizeTimeout

const setMenuHeight = () => {
    const mainElem = document.querySelector('main > section > div') || document.querySelector('main > *')
    const mainHeader = document.querySelector('.main-header')
    if (mainElem && mainHeader) {
        mainElem.style.paddingTop = window.innerWidth > 991 ? `${mainHeader.offsetHeight}px` : '80px'
    }
}

const handleScroll = () => {
    const st = window.scrollY || document.documentElement.scrollTop
    const isScrollingUp = st < lastScrollTop

    const mainHeader = document.querySelector('.main-header')
    if (mainHeader) {
        // Toggle scroll-up class based on scroll position
        mainHeader.classList.toggle('scroll-up', st > 90)

        const showBody = document.querySelector('body.show-body')

        if (st > 360 && !showBody) {
            mainHeader.classList.toggle('scroll-up', isScrollingUp)
            mainHeader.classList.toggle('scroll-down', !isScrollingUp)
        }
    }
    lastScrollTop = Math.max(st, 0)
}

const menu = (element, add) => {
    const toggleMenu = document.getElementById('toggleMenu')
    if (toggleMenu) {
        toggleMenu.addEventListener('click', () => {
            element.classList.toggle(add)
        })
    }
}

const initMenuControl = () => {
    menu(document.body, 'show-body')
    document.querySelector('body').insertAdjacentHTML('afterbegin', `<div class="hide-content"></div>`)

    const navigationLinks = document.querySelectorAll('.page-navigation.container a')
    if (navigationLinks) {
        navigationLinks.forEach(link => {
            link.addEventListener('click', () => {
                document.body.classList.remove('show-body')
            })
        })
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    setMenuHeight()

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(setMenuHeight, 500)
    })
}

export { initMenuControl }
